import React from 'react';
import PropTypes from 'prop-types';
import { TextField, FormHelperText, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ticket from './icons/ic_validacion.svg';

const useStyles = makeStyles(() => ({
  input: {
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderRadius: 5,
    },
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#f1f1f1',
    },
    width: '100%',
  },
  helperText: {
    textAlign: 'right',
  },
  errorText: {
    textAlign: 'right',
    color: 'red',
  },
  image: {
    height: 20,
    width: 20,
  },
}));

const AppInput = ({ ...props }) => {
  const {
    name,
    error,
    value,
    label,
    helperText,
    errorMessage,
    inputAdornment,
    required,
    onChange,
    onBlur,
    onClick,
    type,
    autoComplete,
    disabled,
    success,
    multiline,
  } = props;

  const handleChange = (event) => {
    onChange(event);
  };
  const handleBlur = (event) => {
    onBlur && onBlur(event);
  };
  const handleClick = (event) => {
    onClick(event);
  };

  const classes = useStyles();
  return (
    <React.Fragment>
      <TextField
        data-cy={`input${name}`}
        disabled={disabled}
        name={name}
        error={error}
        type={type}
        value={value}
        label={label}
        autoComplete={autoComplete}
        required={required}
        onChange={handleChange}
        onBlur={handleBlur}
        onClick={handleClick}
        size="small"
        variant="outlined"
        multiline={multiline}
        rows={4}
        InputProps={{
          startAdornment: inputAdornment && (
            <InputAdornment position="start">{inputAdornment}</InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {success && (
                <img
                  className={classes.image}
                  src={ticket}
                  data-cy={`img${name}`}
                />
              )}
            </InputAdornment>
          ),
        }}
        className={classes.input}
      />
      {!error && helperText && (
        <FormHelperText className={classes.helperText}>
          {helperText}
        </FormHelperText>
      )}
      {error && (
        <FormHelperText className={classes.errorText}>
          {errorMessage}
        </FormHelperText>
      )}
    </React.Fragment>
  );
};

AppInput.propTypes = {
  name: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
  errorMessage: PropTypes.string,
  inputAdornment: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  type: PropTypes.string,
  autoComplete: PropTypes.bool,
  disabled: PropTypes.bool,
  success: PropTypes.bool,
  multiline: PropTypes.bool,
};

export default AppInput;
